import * as v from 'valibot'
import {
	queue_order_min,
	queue_wrapUpTimeSeconds_min,
	validators_favicon_url,
	validators_hex_color_error,
	validators_image_url,
	validators_required,
	validators_url,
} from '@/integrations/paraglide/messages/_index.js'

export function UrlSchema(): v.GenericSchema<string> {
	return v.pipe(
		v.string(),
		v.url(validators_url()),
		v.check((input) => input.startsWith('https:'), validators_url()),
	)
}

export function OptionalHttpsSchema(): v.GenericSchema<string> {
	return v.pipe(
		v.string(),
		v.check((input) => {
			if (input === '') return true
			return v.safeParse(UrlSchema(), input).success
		}, validators_url()),
	)
}

export function FaviconSchema(): v.GenericSchema<string> {
	return v.pipe(
		OptionalHttpsSchema(),
		v.check(
			(input) =>
				input === '' ||
				(typeof input === 'string' && /\.(ico|png|svg)$/i.test(input)),
			validators_favicon_url(),
		),
	)
}

export function ImageUrlSchema(): v.GenericSchema<string> {
	return v.pipe(
		OptionalHttpsSchema(),
		v.check(
			(input) =>
				input === '' ||
				(typeof input === 'string' &&
					/\.(png|jpe?g|gif|webp|svg)$/i.test(input)),
			validators_image_url(),
		),
	)
}

export function HexColorSchema(): v.GenericSchema<string> {
	return v.pipe(
		v.string(),
		v.regex(/^#[0-9A-Fa-f]{6}$/, validators_hex_color_error()),
	)
}
export function MatchSchema(
	matchValue: string,
	errorMessage: string,
): v.GenericSchema<string> {
	return v.pipe(
		v.string(),
		v.check((input) => input === matchValue, errorMessage),
	)
}

export function RequiredStringSchema(): v.GenericSchema<string> {
	return v.pipe(v.string(), v.minLength(1, validators_required()))
}

export function RequiredCheckBoxSchema(): v.GenericSchema<unknown, boolean> {
	return v.pipe(
		v.unknown(),
		v.transform((input) => {
			if (Array.isArray(input)) {
				return input.length > 0
			}
			return input === 'on' || input === 'true' || input === true
		}),
		v.boolean(),
		v.literal(true, validators_required()),
	)
}

export function RequiredSchema(): v.GenericSchema<string | boolean | number> {
	return v.pipe(
		v.union([v.string(), v.boolean(), v.number()]),
		v.check((input) => {
			if (typeof input === 'string') {
				return input === 'on' || input === 'true'
			} else if (typeof input === 'boolean') {
				return input
			} else if (typeof input === 'number') {
				return input > 0
			}
			return false
		}, validators_required()),
	)
}

// Queue field validators
export function wrapUpTimeSecondsValidator(): v.GenericSchema<number> {
	return v.pipe(v.number(), v.minValue(0, queue_wrapUpTimeSeconds_min()))
}

export function orderValidator(): v.GenericSchema<number> {
	return v.pipe(v.number(), v.minValue(0, queue_order_min()))
}
